import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LinkNav } from './shell/LinkNav';
// Install the busy/settled marker BEFORE React mounts, so no request escapes it.
import { markReady } from './shell/busy';

/** Sits last in the tree, so its effect runs after every page's mount effect has started (or finished) its
 *  fetches — see markReady's comment. A sibling rendered before <App /> would run its effect too early. */
function ReadyMarker() {
  React.useEffect(() => { markReady(); }, []);
  return null;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The EJS app re-renders from the server on every request; the SPA starts the same way (refetch on
      // navigation, no optimistic updates in v1) so a page means the same numbers in both front ends.
      staleTime: 15_000,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LinkNav />
        <App />
        <ReadyMarker />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
